/* eslint-disable */
import React, { useEffect } from "react";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import type { FC } from "react";
import { useStyles } from "./DownloadFile.styles";
import { useDownloadFileQuery } from "../../api";
import type { IDownloadFileProps } from "./DownloadFile.types";

export const DownloadFile: FC<IDownloadFileProps> = (props) => {
  const classes = useStyles();
  const { fileKey } = props;
  const {isDownloadFileLoading} = useDownloadFileQuery(fileKey);

  return (
    <div>
      <Backdrop className={classes.backdrop} open={isDownloadFileLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};
